import ESIInclude from "@JohnLewisPartnership/jl-esi-components";
import LoadingSpinner from "@/components/loading-spinner/LoadingSpinner";
import React, { useEffect, useState } from "react";
import esiSourceWrapper from "@/constants/esiSourceWrapper";
import { getSolutionContactDetailsByTag } from "@/utils/data/getContactDetails";
import ContactDetailsBox from "@/components/contact-details-box/ContactDetailsBox";
import SlideIn from "@/components/slide-in/SlideIn";
import { useDecisionTreeLocation } from "@/hooks";
import styles from "./screens.module.scss";

function SolutionOther() {
  const [contactConfig, setContactConfig] = useState(null);
  const location = useDecisionTreeLocation();

  useEffect(() => {
    getSolutionContactDetailsByTag("returnsAndRefunds-returningOrExchanging").then(config => setContactConfig(config));
  }, []);

  const contactFields = [
    { name: "phone", key: "number" },
    { name: "chat", key: "channel" },
  ];

  return (
    <div className={styles.landingPageSolutionContainer}>
      <div className={styles.solutionESIContainer}>
        <ESIInclude src={esiSourceWrapper("/content-renderer/content/returnsandrefunds/other")} id="content" />
      </div>
      <div className={styles.solutionViewContactDetailsContainer}>
        {!contactConfig && <LoadingSpinner />}
        {contactConfig ? (
          <SlideIn>
            <ContactDetailsBox
              title="We’re here to help"
              fields={contactFields.filter(({ name }) => ["phone", "chat", "email"].includes(name))}
              solutionId={contactConfig.solution}
              location={location}
              otherContactDetails={contactConfig}
              viewContactDetails
              showContactDetailsByDefault
            />
          </SlideIn>
        ) : null}
      </div>
    </div>
  );
}

export default SolutionOther;
